const FIRST_LOGIN_KEY = "kipabiz_first_login_complete";

export function isFirstLoginPending() {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(FIRST_LOGIN_KEY) !== "1";
}

export function markFirstLoginComplete() {
  if (typeof window === "undefined") return;
  localStorage.setItem(FIRST_LOGIN_KEY, "1");
}
